<div class="d-flex justify-content-end overflow-hidden py-2 actions-toolbar">
  <button mat-icon-button aria-label="Flip" class="w-auto px-2"
          [disabled]="!toTrackGrid?.context?.flip"
          (click)="flipTrack()"
          [class.bg-dark]="toTrackGrid?.context?.flip">
    <mat-icon matTooltip="Flip">
      <i class="fas fa-caret-square-up fa-lg fa-inverse"></i>
    </mat-icon>
    <mat-icon matTooltip="Flip" class="ml-n1">
      <i class="fas fa-caret-square-down fa-lg fa-inverse"></i>
    </mat-icon>
  </button>
  <button mat-icon-button aria-label="Up"
          [disabled]="!toTrackGrid?.context?.up"
          (click)="adjust('U')"
          [class.bg-dark]="toTrackGrid?.context?.up">
    <mat-icon matTooltip="Move Up">
      <i class="fas fa-caret-square-up fa-lg fa-inverse"></i>
    </mat-icon>
  </button>
  <button mat-icon-button aria-label="Down"
          [disabled]="!toTrackGrid?.context?.down"
          (click)="adjust('D')"
          [class.bg-dark]="toTrackGrid?.context?.down">
    <mat-icon matTooltip="Move Down">
      <i class="fas fa-caret-square-down fa-lg fa-inverse"></i>
    </mat-icon>
  </button>
</div>
